import React from 'react'
import ErrorBoundary from './error'
import Backend from './components/Backend'

export default () => <ErrorBoundary><Backend /></ErrorBoundary>

export { backendReducer, actions } from './exports'



// WEBPACK FOOTER //
// ./src/features/Backend/index.js